import { render } from "./viewtask.vue?vue&type=template&id=35d16c6a&scoped=true"
import script from "./viewtask.vue?vue&type=script&lang=js"
export * from "./viewtask.vue?vue&type=script&lang=js"

import "./viewtask.vue?vue&type=style&index=0&id=35d16c6a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d16c6a"]])

export default __exports__